import { render, staticRenderFns } from "./EvaluacionAcademia.vue?vue&type=template&id=b88eb772"
import script from "./EvaluacionAcademia.vue?vue&type=script&lang=js"
export * from "./EvaluacionAcademia.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionAcademia.vue?vue&type=style&index=0&id=b88eb772&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports